<script setup lang="ts">
import Modal from "./Modal.vue";
import ChatNotice from "./ChatNotice.vue";
import type { ConversationNotice } from "../composables/chatTimeline";
import type { EventDetails } from "../composables/eventDetails";
import { t } from "../i18n";
/** "Dados do evento": a conversation notice with who did it, when, and what changed. */
defineProps<{
  open: boolean;
  notice: ConversationNotice | null;
  details: EventDetails | null;
}>();
const emit = defineEmits<{ close: [] }>();
</script>
<template>
  <Modal :open="open" :title="t('event.info.title')" @close="emit('close')">
    <div v-if="notice && details" class="event-info">
      <div class="event-info-preview">
        <ChatNotice
          :variant="notice.variant"
          :text="notice.text"
          :icon="notice.icon"
        />
      </div>
      <dl>
        <div>
          <dt>{{ t("event.info.who") }}</dt>
          <dd>{{ details.who }}</dd>
        </div>
        <div>
          <dt>{{ t("event.info.when") }}</dt>
          <dd>{{ details.when }}</dd>
        </div>
        <div v-for="row in details.rows" :key="row.label">
          <dt>{{ row.label }}</dt>
          <dd>{{ row.value }}</dd>
        </div>
      </dl>
    </div>
    <template v-if="$slots.actions" #footer><slot name="actions" /></template>
  </Modal>
</template>
